import { theme } from "../theme/theme";
export const foreColor = (mode: string) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.main
        : theme.palette.darkColor.foreColor.main,
  };
};
export const foreColorOnMouseOver = (mode: string) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.light
        : theme.palette.darkColor.foreColor.light,
  };
};

export const backgroundColor = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.medium
        : theme.palette.darkColor.backColor.dark,
  };
};
export const backgroundColorDnd = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.medium
        : theme.palette.darkColor.backColor.main,
  };
};
export const backgroundColorDrafts = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.medium
        : theme.palette.darkColor.backColor.light,
  };
};
export const foreColorChecked = (mode: string, isChecked: boolean) => {
  if (isChecked) {
    return {
      color:
        mode === "lite"
          ? theme.palette.liteColor.foreColor.main
          : theme.palette.darkColor.foreColor.main,
    };
  } else {
    return {
      color:
        mode === "lite"
          ? theme.palette.liteColor.backColor.dark
          : theme.palette.darkColor.backColor.light,
    };
  }
};

export const foreColorCode = (mode: string) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.main;
  } else {
    return theme.palette.darkColor.foreColor.main;
  }
};
export const foreColorCodeLite = (mode: string) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.dark;
  } else {
    return theme.palette.darkColor.foreColor.light;
  }
};
export const backGroundColorCode = (mode: string) => {
  if (mode === "lite") {
    return theme.palette.liteColor.backColor.medium;
  } else {
    return theme.palette.darkColor.backColor.dark;
  }
};
export const foreColorCodeOnMouseOver = (mode: string) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.light;
  } else {
    return theme.palette.darkColor.foreColor.light;
  }
};
export const backColorModal = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.light
        : theme.palette.darkColor.backColor.light,
  };
};
export const backColorTableHeader = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.darkColor.backColor.tableHeader
        : theme.palette.darkColor.backColor.tableHeader,
  };
};
export const backColorTableRowAdd = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.tableRowAdd
        : theme.palette.darkColor.backColor.tableRowAdd,
  };
};
export const backColorTableRowEven = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.tableRowEven
        : theme.palette.darkColor.backColor.tableRowEven,
  };
};
